import { IsResponseDataValid } from "../_helpers/ui/helpers";
import SettingsService from "../_services/api/settings/graycorp/settings.service";

export const CXSettings = {
  namespaced: true,
  state: {
    Settings: []
  },
  actions: {
    async loadCXSettings({ commit, state }, message) {
      if (state.Settings.length === 0 || (state.Settings.length > 0 && state.Settings[0].SettingName !== message)) {
        const data = await SettingsService.getBySettingName(message);
        if (IsResponseDataValid(data)) {
          commit("setCXSettings", data.data.value[0]);
        } else {
          commit("setCXSettings", []);
        }
      }
    }
  },
  mutations: {
    setCXSettings(state, settings) {
      state.Settings = settings;
    }
  },
  getters: {
    getCXSettings: (state) => {
      return state.Settings;
    }
  }
};
